import { computed, type Ref } from 'vue';
import { isNull } from '@aviata/type-guards';
import { map } from 'lodash-es';
import type { Airflow } from '@aviata/platform-types';

export function useMarkupNotice(
  offer: Ref<Airflow.Offer.Details['offer'] | null>,
) {
  const AIRLINE_MARKUP_TYPE = 'PROVIDER_SERVICE_FEE';

  const hasMarkup = computed(() => {
    if (!offer?.value || isNull(offer.value.price_breakdown)) {
      return false;
    }
    const priceBreakdownModifiers = new Set(
      map(offer.value.price_breakdown.modifiers, 'type'),
    );
    return priceBreakdownModifiers.has(AIRLINE_MARKUP_TYPE);
  });

  const shouldShowMarkupNotice = computed(() => {
    if (!offer?.value) {
      return false;
    }
    const airlines = new Set(offer.value?.validating_airlines);
    return (
      offer.value.fare_family?.choices.length > 0 &&
      hasMarkup.value &&
      airlines.has('KC-')
    );
  });

  return { shouldShowMarkupNotice };
}
